import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';
import { IConfigOrdemServico } from '../interfaces/finalizacao-ticket/finalizacao-ticket.interface';

@Injectable({
  providedIn: 'root'
})
export class TicketService {
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    params: {}
  };

  constructor(private http: HttpClient, private tokenService: TokenService) { }

  getListagemTipoTickets(params, filtros): Observable<any> {
    this.httpOptions.params = params;
    return this.http.post(`${this.apiUrl}api/chamadoTipo/list`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  createTipoTicket(payload): Observable<any> {
    this.httpOptions.params = "";
    return this.http.post(`${this.apiUrl}api/chamadoTipo`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  updateTipoTicket(payload): Observable<any> {
    this.httpOptions.params = "";
    return this.http.put(`${this.apiUrl}api/chamadoTipo`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getListagemAberturaTickets(params, filtros): Observable<any> {
    this.httpOptions.params = params;
    return this.http.post(`${this.apiUrl}api/categorizacao/personalizada/lista`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  getAberturaTicketPadrao(): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/categorizacao/padrao`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  saveAberturaTicketPadrao(payload): Observable<any> {
    this.httpOptions.params = "";
    return this.http.put(`${this.apiUrl}api/categorizacao/padrao`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  patchConfiguracaoOS(payload: IConfigOrdemServico): Observable<any> {
    this.httpOptions.params = "";
    return this.http.patch(`${this.apiUrl}api/categorizacao/padrao`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  createAberturaTicketPersonalizada(payload): Observable<any> {
    this.httpOptions.params = "";
    return this.http.post(`${this.apiUrl}api/categorizacao/personalizada`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  saveAberturaTicketPersonalizado(payload): Observable<any> {
    this.httpOptions.params = "";
    return this.http.put(`${this.apiUrl}api/categorizacao/personalizada`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  deletarTicketPersonalizado(id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.delete(`${this.apiUrl}api/categorizacao/personalizada/` + id, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  obterPersonalizada(cliente_id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/categorizacao/personalizada/${cliente_id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  salvarConfiguracaoTipoSolicitante(payload): Observable<any> {
    this.httpOptions.params = "";
    return this.http.patch(`${this.apiUrl}api/categorizacao/padrao-solicitante`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é:`, error);
    }
    return throwError(
      error.error);
  }
}
